export default {
    entityKey: 'testing-actions',
    basePath: '/testing-actions',
    titles: {
        singular: 'Action',
        plural: 'Actions'
    }
}
